import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CreateSnapshotModal.module.css";
import ConfirmationModal from "DreamStream/Shared/ConfirmationModal";
import CheckBoxItem from "DreamStream/Shared/CheckBoxItem";
import Input from "shared/@forms/Input";

/**
 * Interactive component.
 * Modal used for creating snapshots in the Snapshots tab of the Events page.
 */
export function CreateSnapshotModal({ isOpen, onClose, onClick }) {
  const [snapshot, setSnapshot] = useState({ isSave: false, name: "" });
  const [note, setNote] = useState({ note: "", add: false });

  useEffect(() => {
    setSnapshot({ isSave: false, name: "" });
    setNote({ note: "", add: false });
  }, [isOpen]);

  return (
    <>
      <div
        className={classNames(styles.blur, {
          [styles.hidden]: !isOpen,
        })}
      />
      <ConfirmationModal
        header="Create Snapshot"
        isOpen={isOpen}
        onClose={onClose}
        onClick={() =>
          onClick({ ...snapshot, note: note.add ? note.note : null })
        }
        description="Capture statistics for who viewed a live stream."
        btnName="Create"
        children={
          <div className={styles.flex}>
            <div className={styles.inline}>
              <label htmlFor="name">Name Snapshot:</label>
              <Input
                name="name"
                type="text"
                value={snapshot.name}
                onChange={(key) =>
                  setSnapshot({ ...snapshot, name: key.target.value })
                }
                placeholder="Click to type"
                className={styles.input}
              />
            </div>
            <div className={styles["check-box"]}>
              <CheckBoxItem
                checked={snapshot.isSave}
                name="Save to the DS database as an attendance snapshot for event reporting"
                onClick={() =>
                  setSnapshot({ ...snapshot, isSave: !snapshot.isSave })
                }
              />
            </div>
            <div className={styles.inline}>
              <CheckBoxItem
                checked={note.add}
                name="Add Note"
                onClick={() => setNote({ ...note, add: !note.add })}
              />
              <label hidden htmlFor="note">
                Note
              </label>
              <Input
                name="note"
                type="text"
                value={note.note}
                onChange={(key) => setNote({ ...note, note: key.target.value })}
                placeholder="Click to type"
                className={classNames(styles.input, {
                  [styles.hidden]: !note.add,
                })}
              />
            </div>
          </div>
        }
      />
    </>
  );
}

CreateSnapshotModal.propTypes = {
  /**
   * Boolean to determine if modal is open.
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when the create button is clicked.
   */
  onClick: PropTypes.func,
};
